import { createFileRoute } from '@tanstack/react-router';
import { EntityStyleProductDocumentsTable } from '@/app/(client)/my-styles/-components/EntityStyleProductDocumentsTable';
import {
  isEntityKindPath,
  useEntityDetail,
} from '@/app/(client)/my-styles/-hooks/useEntityDetail';
import { styleDocumentsQueryOptions } from '@/app/(client)/my-styles/-hooks/useStyleDocumentsQuery';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents/product-only/',
)({
  loader: ({ params }) =>
    queryClient.ensureQueryData(
      styleDocumentsQueryOptions(params.id, { page: 1, count: 20 }),
    ),
  component: ProductOnlyDocumentsRoute,
});

function ProductOnlyDocumentsRoute() {
  const { kind, id } = Route.useParams();
  const safeKind = isEntityKindPath(kind) ? kind : 'styles';
  const { data: entity } = useEntityDetail(safeKind, id);
  const entityName = entity?.name ?? '';
  return (
    <EntityStyleProductDocumentsTable entityId={id} entityName={entityName} />
  );
}
